import Fetch, { V1 } from 'Util/fetcher';

const INITIAL_STATE = {
    stockHighlightLoading: null,
    stockHighlightData: null,
    stockHighlightError: null,
  
    stockHighlightDetailLoading: false,
    stockHighlightDetailData: null,
    stockHighlightDetailError: null,
};

const ON_REQUEST_STOCK_HIGHLIGHT = 'ON_REQUEST_STOCK_HIGHLIGHT';
const ON_REQUEST_STOCK_HIGHLIGHT_FAILURE = 'ON_REQUEST_STOCK_HIGHLIGHT_FAILURE';
const ON_REQUEST_STOCK_HIGHLIGHT_SUCCESS = 'ON_REQUEST_STOCK_HIGHLIGHT_SUCCESS';

const ON_REQUEST_STOCK_HIGHLIGHT_DETAIL = 'ON_REQUEST_STOCK_HIGHLIGHT_DETAIL';
const ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_FAILURE = 'ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_FAILURE';
const ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_SUCCESS = 'ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_SUCCESS';

function onRequestStockHighlight(payload) { 
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT,
      payload
    };
  }
  
  function onRequestStockHighlightSuccess(payload) {
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT_SUCCESS,
      payload,
    };
  }
  
  function onRequestStockHighlightFailure(payload) {
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT_FAILURE,
      payload,
    };
  }

  export const onDoRequestStockHighlight = () => (dispatch) => {
    dispatch(onRequestStockHighlight());
    Fetch.get(`${V1}stock/data/story-highlight/discovery/?full=`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockHighlightSuccess(resp.json));
        } else {
          dispatch(onRequestStockHighlightFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockHighlightFailure(error.message));
      });
  };

  function onRequestStockHighlightDetail() {
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT_DETAIL,
    };
  }
  function onRequestStockHighlightDetailSuccess(payload) {
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_SUCCESS,
      payload,
    };
  }
  function onRequestStockHighlightDetailFailure(payload) {
    return {
      type: ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_FAILURE,
      payload,
    };
  }

  export const onDoRequestStockHighlightDetail = code => (dispatch) => {
    dispatch(onRequestStockHighlightDetail());
    Fetch.get(`${V1}stock/data/story-highlight/detail/${code}/`).then((resp) => { 
      if (resp.ok) { 
        dispatch(onRequestStockHighlightDetailSuccess(resp.json));
      } else {
        dispatch(onRequestStockHighlightDetailFailure(resp.json));
      }
    }).catch((error) => {
      dispatch(onRequestStockHighlightDetailFailure(error.message));
    });
  };


const stockHighlight = (state = INITIAL_STATE, action = {}) => {
switch (action.type) {
    case ON_REQUEST_STOCK_HIGHLIGHT:
      return {
          ...state,
          stockHighlightLoading: {
          ...state.stockHighlightLoading,
          },
      };
    case ON_REQUEST_STOCK_HIGHLIGHT_SUCCESS:
      return {
          ...state,
          stockHighlightLoading: true,
          stockHighlightData: action.payload,
          stockHighlightFailure: null,
      };
    case ON_REQUEST_STOCK_HIGHLIGHT_FAILURE:
      return {
        ...state,
        stockHighlightDetailLoading: false,
        stockHighlightDetailError: action.payload
      };
      case ON_REQUEST_STOCK_HIGHLIGHT_DETAIL:
        return {
          ...state,
          stockHighlightDetailLoading: true,
          stockHighlightDetailError: null
        };
      case ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_SUCCESS:
        return {
          ...state,
          stockHighlightDetailLoading: false,
          stockHighlightDetailData: action.payload,
          stockHighlightDetailError: null
        };
      case ON_REQUEST_STOCK_HIGHLIGHT_DETAIL_FAILURE:
        return {
          ...state,
          stockHighlightDetailLoading: false,
          stockHighlightDetailError: action.payload
        };
    default:
      return state;
  }
};

export default stockHighlight;
